import { render, staticRenderFns } from "./ServiceExtend.vue?vue&type=template&id=7f54b964&scoped=true&"
import script from "./ServiceExtend.vue?vue&type=script&lang=js&"
export * from "./ServiceExtend.vue?vue&type=script&lang=js&"
import style0 from "./ServiceExtend.vue?vue&type=style&index=0&id=7f54b964&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f54b964",
  null
  
)

export default component.exports